import React, {useState, useEffect, useCallback} from 'react'
import API from '../../utils/API'
import FullCalendar from '@fullcalendar/react'
import dayGridPlugin from '@fullcalendar/daygrid'
import interactionPlugin from "@fullcalendar/interaction"; 
import timeGridPlugin from '@fullcalendar/timegrid'
import socketIOClient from 'socket.io-client';
import { useHistory } from 'react-router-dom';
export default function EventsCalendar() {
    const history = useHistory();
    const [events, setEvents] = useState([])
    // const endpoint = "http://localhost:3001";
    const endpoint = "/";
    const socket = socketIOClient(endpoint);

    var reser = []

    Object.keys(events).map((item) => (
        reser.push({
            start: events[item].eventDate + 'T' + events[item].eventTime,
            title: events[item].eventTitle,
            publicID: events[item]._id,
            description: events[item].eventDescription
        })        
    ))
    const handleOnClick = useCallback((id) => history.push('/EventDetails/' + id.event._def.extendedProps.publicID ), [history]);
    // const testClick = (id)=>{
    //     console.log(id.event._def.extendedProps.publicID)
    // }
    socket.on('reservationChangeEvent', async () =>{
        try{
        await API.getEvents().then(
            
                function (response) {
                setEvents(response.data)
                })
        }
        catch(error){
            console.log('THIS IS THE ERROR!', error)
        }
    })

    useEffect(() => {
        API.getEvents().then(
            function(response){
                setEvents(response.data)
            }
        )
    }, []);
    return (
        <div>
        <FullCalendar
                    
                    headerToolbar={{
                        start: 'title',
                        right: 'prev,next',
                        center: 'dayGridMonth,timeGridWeek,timeGridDay'
                    }}
                        plugins={[ dayGridPlugin, interactionPlugin, timeGridPlugin ]}
                        initialView="dayGridMonth"
                        events={reser}
                        eventClick={handleOnClick}
        />
        </div>
    )
}
